import { render, staticRenderFns } from "./FamilyHistoryPhase.vue?vue&type=template&id=599b1e05&scoped=true&"
import script from "./FamilyHistoryPhase.vue?vue&type=script&lang=js&"
export * from "./FamilyHistoryPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b1e05",
  null
  
)

export default component.exports